import React,{Component} from 'react';
import { ref } from '../config/constants'



class ProductFields extends Component{
    constructor(){
        super();
        this.handleChange = this.handleChange.bind(this);
        this.data = this.data.bind(this);
        this.state ={
            categoryList : {},
            productsList : {}
        }
    }

    componentWillMount() {

        var category = ref.child("Categories")
            category.on("value", function(snap){
                this.setState({
                    categoryList : snap.val()
                })
            }.bind(this))     
    }

    handleChange(e){
        let products = ref.child("Products").orderByChild("category").equalTo(this.category.value)
                products.on("value",function(snap){
                    
                    this.setState({
                        productsList : snap.val()
                    })

                }.bind(this))
    }

    data(index){
       // console.log(this.product.value + index)
        let product = this.product.value
        let category = this.category.value
        if(category && product){
            this.props.setList(index,product,category)
        }else{
            alert("Incomplete the fields");
        }
    }
          
    render() {

        return (
            <div className="row">
                <div className="col-md-3">
                <select className="form-control" ref={(input)=>{this.category=input}} onChange={this.handleChange}>
                    <option></option>
                    { 
                        this.state.categoryList &&
                        Object.keys(this.state.categoryList).map(function (key){
                            let list = this.state.categoryList[key]
                            return <option value={list.category} key={key}> {list.category} </option>
                       }.bind(this))
                    }
                </select>
                </div>
                <div className="col-md-3">
                <select className="form-control col-md-3"  ref={(input)=>{this.product=input}} onChange={()=>this.data(this.props.index)}>
                    <option></option>
                    { 
                        this.state.productsList &&
                        Object.keys(this.state.productsList).map(function (key){
                            let list = this.state.productsList[key]

                            if(list.status==="Active"){
                                return <option value={key} key={key}> {list.name} </option>
                            }else{
                                return false;
                            }
                       }.bind(this))
                    }
                </select>
                </div>
                <button type="submit" className="btn btn-sm btn-danger" onClick={()=>this.props.remove(this.props.index)}> x </button>   
            </div>
        );
    }
}

export default  ProductFields;



// WEBPACK FOOTER //
// ./src/components/ProductFields.js